import {Component, EventEmitter, Input} from "@angular/core";
import {FormModel} from "../form/form.model.abstract";

/**
 * Componwent for a prest mark on automatic presetted fields
 */
@Component({
    selector: 'app-formfield-presetmark',
    templateUrl: './formfield.presetmark.component.html',
    standalone: false
})
export class FormfieldPresetmarkComponent {
  /**
   * The formModel that was presetted
   */
  @Input() formModel: FormModel;

  /**
   * event handler for click events on the icon
   */
  @Input() onClick: EventEmitter<boolean> = null;

  /**
   * toggle to enable/disable the moseclick
   */
  @Input() noClick: boolean = false;

  /**
   * handle the click on the icon
   */
  click(): void {
    if(this.formModel.hasInfotext() && this.noClick === false && this.onClick) {
      this.onClick.emit(true);
    }
  }
}
